import CredentialReducer from './credentialReducer';
import IOReducer from './ioReducer';
import LiteratureWizardReducer from './literatureWizardReducer';
import NotificationReducer from './notificationReducer';

export {CredentialReducer, IOReducer, LiteratureWizardReducer, NotificationReducer};


// WEBPACK FOOTER //
// ./src/reducers/index.ts